import Button from 'components/Button'
import InputField from 'components/Form/Inputs/InputField/component'
import Loader from 'components/Loader'
import { useGetRecipeCategoriesQuery } from 'containers/recipeCategories/queries'
import { useState } from 'react'
import { Link, Outlet, useLocation, useNavigate } from 'react-router-dom'
import { ApiQueryParams, useUrlFilter } from 'utils/routing/useUrlFilter'
import { useGetRecipesQuery } from './queries'
import { RecipeInList } from './recipeInList'

function Recipes() {
    const navigate = useNavigate()
    const { search: locationSearch } = useLocation()

    const { filter: filterCategories } = useUrlFilter('categories')
    const { filter: filterIngredients } = useUrlFilter('includes_ingredients')

    const [search, setSearch] = useState('')

    const apiFilters: ApiQueryParams['filters'] = []
    if (filterCategories) {
        apiFilters.push({
            name: 'categories',
            content: filterCategories
        })
    }
    if (filterIngredients) {
        apiFilters.push({
            name: 'includes_ingredients',
            content: filterIngredients
        })
    }

    const { data: recipesData, isFetching: isRecipesFetching, isError: isRecipesError } = useGetRecipesQuery({ filters: apiFilters })

    const {
        data: getRecipeCategoriesData,
        isFetching: isGetRecipeCategoriesFetching,
        isError: isGetRecipeCategoriesError
    } = useGetRecipeCategoriesQuery()

    if (isRecipesFetching || isGetRecipeCategoriesFetching) return <Loader fullPage />
    if (isRecipesError || !recipesData || !getRecipeCategoriesData || isGetRecipeCategoriesError) return <h1>Recipes error</h1>

    const safeFilterCategories = filterCategories?.value ?? []
    const safeFilterIngredients = filterIngredients?.value ?? []
    const numberOfActiveFilters = [safeFilterCategories, safeFilterIngredients].reduce((acc, curr) => acc + (curr.length > 0 ? 1 : 0), 0)

    const filteredRecipes = search ? recipesData.filter(({ name }) => name.toLowerCase().includes(search.toLowerCase())) : recipesData

    const noRecipesMessage =
        search || numberOfActiveFilters > 0
            ? 'No recipes matched your search.'
            : 'You don\'t currently have any recipes. Use the "Add New" button to create a recipe.'

    return (
        <div className='p-4'>
            <h2 className='mb-4'>Recipes</h2>
            <div className='flex justify-between mt-4 w-full'>
                <Button onClick={() => navigate('/recipes/new')}>Add New</Button>
                <InputField
                    name='search'
                    placeholder='Search for a recipe'
                    value={search}
                    onChange={(e) => setSearch(e.target.value)}
                    hasClearButton
                />
            </div>
            <div className='flex gap-4 mt-4'>
                <Link to={`/recipes/filters${locationSearch}`}>Filters{numberOfActiveFilters > 0 ? ` (${numberOfActiveFilters})` : ''}</Link>
            </div>
            <div className='mt-8'>
                {filteredRecipes.length > 0 ? (
                    <div className='grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 2xl:grid-cols-5 gap-x-8 gap-y-10'>
                        {filteredRecipes.map((recipe) => {
                            return (
                                <RecipeInList
                                    key={recipe.id}
                                    id={recipe.id}
                                    category={recipe.recipe_category?.name ?? null}
                                    name={recipe.name}
                                    imageUrl={recipe.image_url}
                                />
                            )
                        })}
                    </div>
                ) : (
                    <p>{noRecipesMessage}</p>
                )}
            </div>
            <Outlet />
        </div>
    )
}

export default Recipes
